export const posthogHost = 'https://us.i.posthog.com';
